"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverTitle: function() {
        return _index.TeachingPopoverTitle;
    },
    renderTeachingPopoverTitle_unstable: function() {
        return _index.renderTeachingPopoverTitle_unstable;
    },
    teachingPopoverTitleClassNames: function() {
        return _index.teachingPopoverTitleClassNames;
    },
    useTeachingPopoverTitleStyles_unstable: function() {
        return _index.useTeachingPopoverTitleStyles_unstable;
    },
    useTeachingPopoverTitle_unstable: function() {
        return _index.useTeachingPopoverTitle_unstable;
    }
});
const _index = require("./components/TeachingPopoverTitle/index");
